/**
 * @description Module recherche de l'en-tête
 */

/* global ModuloTS $toggle */

(() => {
	// VARS
	const root = document.querySelector('[data-js-header-search-root]');
	root.querySelector('input[type="text"]').setAttribute(
		'placeholder',
		ModuloTS['What are you looking for ?']
	);

	const toggle = () => {
		const submit = root.parentNode.querySelector('input[type=submit]');

		submit.tabIndex = -1;
		root.querySelector('[data-js-header-search-toggle]').addEventListener(
			'click',
			() => {
				root.parentNode.classList.toggle('active');
				if (root.parentNode.classList.contains('active')) {
					submit.tabIndex = 0;

					document
						.querySelector('.layout-container')
						.addEventListener('click', () => {
							root.parentNode.classList.remove('active');
						});
				} else {
					const autocomplete = root.parentNode.querySelector(
						'.search-api-autocomplete-search'
					);
					submit.tabIndex = -1;
					autocomplete.tabIndex = -1;
				}
			}
		);

		submit.addEventListener('keydown', (e) => {
			const isTabPressed = e.key === 'Tab';

			if (!isTabPressed) {
				return;
			}

			// if focused has reached to last focusable element then focus first focusable element after pressing tab
			root.querySelector('[data-js-header-search-toggle]').focus(); // add focus for the first focusable element
			e.preventDefault();
		});
	};

	window.addEventListener('load', () => {
		const autocomplete = document.querySelector(
			'.ui-autocomplete.ui-front'
		);
		root.querySelector('form').appendChild(autocomplete);
	});

	// GO 🚀
	const init = () => {
		if (document.body.contains(root)) {
			toggle();
		}
	};

	init();
})();
